// @flow
import type { CSS } from 'glamorous'
import { pxToRem } from './util'

export const small = (styles: CSS) => ({
  [`@media screen and (max-width: ${pxToRem(640)})`]: {
    ...styles,
  },
})



// WEBPACK FOOTER //
// ./src/style/breakpoint.js